module.exports = __webpack_public_path__ + "img/supplierLanding.a81deffa.png";